var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWide1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.4,
    y: 3.4,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#1E3A8A",
    stroke: "#1E3A8A",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 6C18.5 5.72386 18.2761 5.5 18 5.5L13.5 5.5C13.2239 5.5 13 5.72386 13 6C13 6.27614 13.2239 6.5 13.5 6.5H17.5V10.5C17.5 10.7761 17.7239 11 18 11C18.2761 11 18.5 10.7761 18.5 10.5L18.5 6ZM13.3536 11.3536L18.3536 6.35355L17.6464 5.64645L12.6464 10.6464L13.3536 11.3536Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 18C5.5 18.2761 5.72386 18.5 6 18.5L10.5 18.5C10.7761 18.5 11 18.2761 11 18C11 17.7239 10.7761 17.5 10.5 17.5H6.5V13.5C6.5 13.2239 6.27614 13 6 13C5.72386 13 5.5 13.2239 5.5 13.5L5.5 18ZM10.6464 12.6464L5.64645 17.6464L6.35355 18.3536L11.3536 13.3536L10.6464 12.6464Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWide1);
export default __webpack_public_path__ + "static/media/Wide_1.c4f60396cea0403d25ab385a38914a6f.svg";
export { ForwardRef as ReactComponent };